import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import * as Yup from "yup";

import { useDispatch, useSelector } from "react-redux";
import {
  createWallet,
  deleteWallet,
  getWallet,
  getWallets,
  updateWalletInfoFun,
} from "slices/thunk";
import { createSelector } from "reselect";
import Spinners from "Components/Common/Spinner";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import { decryptState } from "shared/encryptInfo";
import {
  getCryptoCurrencies,
  getFiatCurrencies,
  getNetworkWallet,
} from "../../helpers/dataBackend";
import Select from "react-select";
import { RootState } from "slices";
import { setAuthorization } from "../../helpers/api_helper";

const WalletActivities = ({ walletHistory }: any) => {
  const dispatch = useDispatch<any>();

  const selectProperties = createSelector(
    (state: any) => state.crypto,
    (crypto) => ({
      WalletActivities: walletHistory,
      loading: crypto?.loading,
    })
  );

  const { loading } = useSelector(selectProperties);
  const wallets = useSelector((state: RootState) => state.WalletReducer.wallet);
  //ESTADOS
  const [currencyType, setCurrencyType] = useState<number>(1);
  const [walletsData, setWalletsData] = useState<any>([]);
  // console.log(walletsData);
  const [walletDataEdit, setWalletDataEdit] = useState<any>([]);
  const [walletDataInfo, setWalletDataInfo] = useState<any>({});
  const [fiatCurrencies, setFiatCurrencies] = useState<any>([]);
  const [cryptoCurrency, setCryproCurrencies] = useState<any>([]);
  const [networkWallet, setNetworksWallet] = useState<any>([]);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [modal, setModal] = useState<boolean>(false);
  const [modalInfo, setModalInfo] = useState<boolean>(false);
  const [walletId, setWalletId] = useState<number>(0);

  // TODO - PAGIANCION
  // Estado para la página actual y cantidad de elementos por página
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(5); // Ajusta este número según lo que necesites

  // Cálculos para obtener los elementos de la página actual
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = walletsData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(walletsData.length / itemsPerPage);
  // ---------------------------------------------
  const [selectedFiat, setSelectedFiat] = useState<any>();
  const [selectedCrypto, setSelectedCrypto] = useState<any>();
  const [selectedNetwork, setSelectedNetwork] = useState<any>();

  const optionsFiat = fiatCurrencies.map((fiat) => ({
    value: fiat.id,
    label: fiat.name,
  }));
  const optionsCrypto = cryptoCurrency.map((fiat) => ({
    value: fiat.id,
    label: fiat.name,
  }));
  const optionsNetwork = networkWallet.map((fiat) => ({
    value: fiat.id,
    label: fiat.name,
  }));

  const handleChange = (selectedOptions) => {
    setSelectedFiat(selectedOptions.value);
  };
  const handleChangeCrypto = (selectedOptions) => {
    setSelectedCrypto(selectedOptions.value);
  };
  const handleChangeNetwork = (selectedOptions) => {
    setSelectedNetwork(selectedOptions.value);
  };

  const [isLoading, setLoading] = useState<boolean>(loading);

  // Alternar modal
  const toggle = useCallback(() => {
    setModal((prev) => !prev);
  }, []);
  // Alternar modal Informativa
  const toggleinfo = useCallback(() => {
    setModalInfo((prev) => !prev);
  }, []);

  // validation
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: (walletDataEdit && walletDataEdit.name) || "",
      balance: "",
      crypto_currency_id: "",
      fiat_currency_id: "",
      network_id: "",
      wallet_entity_id: "",
      status_id: "",
      wallet_type: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Your Name"),
    }),
    onSubmit: (values: any) => {
      if (isEdit) {
        const editWallet: any = {
          id: walletDataEdit.id,
          name: values.name,
        };
        // console.log(editWallet);
        dispatch(updateWalletInfoFun(editWallet));
        validation.resetForm();
        setIsEdit(false);
      } else {
        const newWallet: any = {
          name: values.name,
          description: values.description,
          balance: 0.0,
          network_id: selectedNetwork,
          wallet_entity_id: walletId,
          status_id: 1,
          wallet_type: "",
        };
        if (selectedFiat) {
          newWallet.fiat_currency_id = selectedFiat;
        } else {
          newWallet.crypto_currency_id = selectedCrypto;
        }
        dispatch(createWallet(newWallet));
        validation.resetForm();
      }
      toggle();
    },
  });

  // Disparar la acción solo una vez al montar el componente
  useEffect(() => {
    dispatch(getWallet());
  }, [dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("authUser");
        setAuthorization(token);
        const infoUser = localStorage.getItem("userInfo");
        const { wallet_entity_id } = decryptState(infoUser);
        setWalletId(wallet_entity_id);

        const fiat_currencies = await getFiatCurrencies();
        setFiatCurrencies(fiat_currencies);
        const crypto_currencies = await getCryptoCurrencies();
        setCryproCurrencies(crypto_currencies);
        const networks_wallet = await getNetworkWallet();
        setNetworksWallet(networks_wallet);
        setIsEdit(false);
      } catch (error) {
        console.error("Error al obtener datos:", error);
      }
    };

    fetchData();
  }, []); // Solo ejecuta fetchData una vez al montar el componente

  // Detectar cambios en wallets y actualizar el estado
  useEffect(() => {
    console.log(wallets);
    if (wallets && wallets.length > 0) {
      setWalletsData(wallets.flatMap((item) => item.wallets));
    }
  }, [wallets]);

  useEffect(() => {
    setCurrentPage(walletHistory);
  }, [walletHistory]);

  //MANEJO PARA EDITAR ROLE
  const handleEditWallet = (roleId: number) => {
    const wallet = walletsData.filter((wallet: any) => wallet.id === roleId);
    setWalletDataEdit({
      id: wallet[0].id,
      name: wallet[0].name,
    });

    setIsEdit(true);
    setModal(true);
  };

  //MANEJO PARA EDITAR ROLE
  const handleWalletInfo = (roleId: number) => {
    const wallet = walletsData.filter((wallet: any) => wallet.id === roleId);
    setWalletDataInfo(wallet[0]);

    setModalInfo(true);
  };

  const onClickDelete = (id: any, status_id: any) => {
    dispatch(getWallet());
    if (wallets) {
      wallets.map((item) => setWalletsData(item.wallets));
    }
    dispatch(deleteWallet({ id, status_id }));
  };

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <CardTitle tag="h4" className="mb-4">
            Wallet Accounts
          </CardTitle>
          {isLoading ? (
            <Spinners setLoading={setLoading} />
          ) : (
            <>
              <div className="mb-2 row">
                <div className="col-sm-2">
                  <select
                    className="form-select pageSize mb-2"
                    onChange={(e) => {
                      setItemsPerPage(parseInt(e.target.value));
                      // console.log(itemsPerPage);
                    }}
                  >
                    <option value="5">Show 5</option>
                    <option value="10">Show 10</option>
                    <option value="20">Show 20</option>
                    <option value="30">Show 30</option>
                    <option value="40">Show 40</option>
                    <option value="50">Show 50</option>
                  </select>
                </div>
                <div className="col-sm-4">
                  <Input
                    className="form-control search-box me-2 mb-2 d-inline-block"
                    placeholder="Search..."
                    value=""
                    type="text"
                  />
                </div>
                {/* HABILITAR PATA CUANDO ESTE DISPONIBLE ESTA OPCION */}
                {/* <div className="col-sm-6">
                  <div className="text-sm-end">
                    <button
                      type="button"
                      className="btn btn-success btn-rounded waves-effect waves-light addContact-modal mb-2 btn btn-secondary"
                      onClick={() => {
                        setModal(true);
                      }}
                    >
                      <i className="mdi mdi-plus me-1"></i> New Wallet Account
                    </button>
                  </div>
                </div> */}
              </div>
              <div className="table-responsive">
                <Table className="table mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>#</th>
                      <th>Nombre</th>
                      <th>Balance</th>
                      <th>Currency</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {walletsData.map((item, index) => (
                      <tr key={item.id}>
                        <th scope="row" style={{ width: "50px" }}>
                          {item.id}
                        </th>
                        <td style={{ width: "200px" }}>{item.name}</td>
                        <td style={{ width: "200px" }}>{item.balance}</td>
                        {item.crypto_currency_id !== null && (
                          <td style={{ width: "200px" }}>
                            {cryptoCurrency.map((currency) =>
                              currency.id === item.crypto_currency_id
                                ? currency.name
                                : null
                            )}
                          </td>
                        )}
                        {item.fiat_currency_id !== null && (
                          <td style={{ width: "200px" }}>
                            {fiatCurrencies.map((currency) =>
                              currency.id === item.fiat_currency_id
                                ? currency.name
                                : null
                            )}
                          </td>
                        )}
                        {/* BOTOTNES DE ACCION */}
                        <td style={{ width: "100px" }}>
                          <div className="d-flex gap-3 align-content-center">
                            {/* EDITAR */}
                            {item.name === "ENTITY_ROLE" ? null : (
                              <Link
                                className="text-success"
                                style={{ fontSize: "25px" }}
                                to={"#!"}
                                onClick={() => handleEditWallet(item.id)}
                              >
                                <i className="bx bxs-edit-alt"></i>
                              </Link>
                            )}

                            {/* ELIMINAR */}
                            {item.name === "ENTITY_ROLE" ? null : (
                              <Link
                                style={{ fontSize: "25px" }}
                                className="text-danger"
                                to={"#!"}
                              >
                                {item.status_id === 1 && (
                                  <i
                                    className="bx bxs-trash-alt"
                                    onClick={() =>
                                      onClickDelete(item.id, item.status_id)
                                    }
                                  ></i>
                                )}
                                {item.status_id === 2 && (
                                  <i
                                    className="mdi mdi-reload"
                                    onClick={() =>
                                      onClickDelete(item.id, item.status_id)
                                    }
                                  ></i>
                                )}
                              </Link>
                            )}

                            {/* VIEW */}
                            {item.name === "ENTITY_ROLE" ? null : (
                              <Link
                                className="text-info"
                                style={{ fontSize: "25px" }}
                                to={"#!"}
                                onClick={() => handleWalletInfo(item.id)}
                              >
                                <i className="mdi mdi-eye"></i>
                              </Link>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                {/* PAGINACION */}
                <div
                  className="pagination"
                  style={{ marginTop: "20px", textAlign: "center" }}
                >
                  <button
                    className="btn btn-success btn-rounded mb-2 "
                    onClick={() =>
                      setCurrentPage((prev) => Math.max(prev - 1, 1))
                    }
                    disabled={currentPage === 1}
                    style={{ marginRight: "10px" }}
                  >
                    Prev
                  </button>
                  {Array.from({ length: totalPages }, (_, i) => (
                    <button
                      className="btn btn-danger btn-rounded mb-2 "
                      key={i + 1}
                      onClick={() => setCurrentPage(i + 1)}
                      style={{
                        margin: "0 5px",
                        fontWeight: currentPage === i + 1 ? "bold" : "normal",
                      }}
                    >
                      {i + 1}
                    </button>
                  ))}
                  <button
                    className="btn btn-success btn-rounded mb-2 "
                    onClick={() =>
                      setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                    }
                    disabled={currentPage === totalPages}
                    style={{ marginLeft: "10px" }}
                  >
                    Next
                  </button>
                </div>
              </div>
            </>
          )}
        </CardBody>
      </Card>

      {/* MODAL PARA AGREGAR O EDITAR */}
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle} tag="h4">
          {" "}
          {!!isEdit ? "Edit Wallet" : "Add Wallet"}
        </ModalHeader>
        <ModalBody>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <Row>
              <Col xs={12}>
                {/* NAME */}
                <div className="mb-3">
                  <Label>Name</Label>
                  <Input
                    name="name"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name || ""}
                    invalid={
                      validation.touched.name && validation.errors.name
                        ? true
                        : false
                    }
                  />
                  {validation.touched.name && validation.errors.name ? (
                    <FormFeedback type="invalid">
                      {validation.errors.name}
                    </FormFeedback>
                  ) : null}
                </div>

                {/* SELECCIONA TIPO DE MONEDA */}
                <label className="justify-content-center" hidden={isEdit}>
                  Selecciona el tipo de moneda
                </label>
                <div className="d-flex flex-wrap">
                  <div className="btn-group" role="group">
                    {/* Opción Fiat */}
                    <input
                      type="radio"
                      className="btn-check"
                      name="currency"
                      id="btnFiat"
                      autoComplete="off"
                      value="Fiat"
                      hidden={isEdit}
                      checked={currencyType === 1}
                      onChange={() => setCurrencyType(1)}
                    />
                    <label
                      hidden={isEdit}
                      className="btn btn-secondary"
                      htmlFor="btnFiat"
                    >
                      Fiat
                    </label>

                    {/* Opción Crypto */}
                    <input
                      type="radio"
                      className="btn-check"
                      name="currency"
                      id="btnCrypto"
                      autoComplete="off"
                      value="Crypto"
                      hidden={isEdit}
                      checked={currencyType === 2}
                      onChange={() => setCurrencyType(2)}
                    />
                    <label
                      hidden={isEdit}
                      className="btn btn-secondary"
                      htmlFor="btnCrypto"
                    >
                      Crypto
                    </label>
                  </div>
                </div>

                {/* Fiat Currencies */}
                {isEdit ? null : (
                  <>
                    {/* CRYPTO */}
                    {currencyType === 1 && (
                      <>
                        <label className="form-label">Fiat Currency</label>
                        <Select
                          name="colors"
                          options={optionsFiat}
                          placeholder="Selecciona una Fiat"
                          className="basic-multi-select"
                          classNamePrefix="select"
                          closeMenuOnSelect={false}
                          onChange={handleChange}
                          styles={{
                            option: (base, { isSelected, isFocused }) => ({
                              ...base,
                              backgroundColor: isSelected
                                ? "#3b82f6"
                                : isFocused
                                ? "#e9f5ff"
                                : "white",
                              color: isSelected ? "white" : "black",
                              cursor: "pointer",
                              fontWeight: isSelected ? "bold" : "normal",
                              ":hover": {
                                backgroundColor: isSelected
                                  ? "#1e40af"
                                  : "#e9f5ff",
                                color: "black",
                              },
                            }),
                            multiValue: (base) => ({
                              ...base,
                              backgroundColor: "#3b82f6",
                              color: "white",
                              borderRadius: "5px",
                              padding: "2px 5px",
                            }),
                            multiValueLabel: (base) => ({
                              ...base,
                              color: "white",
                              fontWeight: "bold",
                            }),
                            multiValueRemove: (base) => ({
                              ...base,
                              color: "white",
                              ":hover": {
                                backgroundColor: "#1e40af",
                                color: "white",
                              },
                            }),
                          }}
                        />
                      </>
                    )}

                    {/* FIAT */}
                    {currencyType === 2 && (
                      <>
                        <label className="form-label">Crypto Currency</label>
                        <Select
                          name="colors"
                          options={optionsCrypto}
                          placeholder="Selecciona una Crypto"
                          className="basic-multi-select"
                          classNamePrefix="select"
                          closeMenuOnSelect={false}
                          onChange={handleChangeCrypto}
                          styles={{
                            option: (base, { isSelected, isFocused }) => ({
                              ...base,
                              backgroundColor: isSelected
                                ? "#3b82f6"
                                : isFocused
                                ? "#e9f5ff"
                                : "white",
                              color: isSelected ? "white" : "black",
                              cursor: "pointer",
                              fontWeight: isSelected ? "bold" : "normal",
                              ":hover": {
                                backgroundColor: isSelected
                                  ? "#1e40af"
                                  : "#e9f5ff",
                                color: "black",
                              },
                            }),
                            multiValue: (base) => ({
                              ...base,
                              backgroundColor: "#3b82f6",
                              color: "white",
                              borderRadius: "5px",
                              padding: "2px 5px",
                            }),
                            multiValueLabel: (base) => ({
                              ...base,
                              color: "white",
                              fontWeight: "bold",
                            }),
                            multiValueRemove: (base) => ({
                              ...base,
                              color: "white",
                              ":hover": {
                                backgroundColor: "#1e40af",
                                color: "white",
                              },
                            }),
                          }}
                        />
                      </>
                    )}

                    {/* Network */}
                    {currencyType === 2 && (
                      <>
                        <label className="form-label mt-3">Network</label>
                        <Select
                          name="colors"
                          // defaultValue={rolesDataEdit.map((permiso) => ({
                          //   value: permiso.id,
                          //   label: permiso.name,
                          // }))} // Convertimos los permisos existentes al formato de opciones
                          options={optionsNetwork}
                          placeholder="Seleccionar roles..."
                          className="basic-multi-select"
                          classNamePrefix="select"
                          closeMenuOnSelect={false}
                          onChange={handleChangeNetwork}
                          styles={{
                            option: (base, { isSelected, isFocused }) => ({
                              ...base,
                              backgroundColor: isSelected
                                ? "#3b82f6"
                                : isFocused
                                ? "#e9f5ff"
                                : "white",
                              color: isSelected ? "white" : "black",
                              cursor: "pointer",
                              fontWeight: isSelected ? "bold" : "normal",
                              ":hover": {
                                backgroundColor: isSelected
                                  ? "#1e40af"
                                  : "#e9f5ff",
                                color: "black",
                              },
                            }),
                            multiValue: (base) => ({
                              ...base,
                              backgroundColor: "#3b82f6",
                              color: "white",
                              borderRadius: "5px",
                              padding: "2px 5px",
                            }),
                            multiValueLabel: (base) => ({
                              ...base,
                              color: "white",
                              fontWeight: "bold",
                            }),
                            multiValueRemove: (base) => ({
                              ...base,
                              color: "white",
                              ":hover": {
                                backgroundColor: "#1e40af",
                                color: "white",
                              },
                            }),
                          }}
                        />
                      </>
                    )}
                  </>
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="text-end mt-4">
                  <Button type="submit" color="success" className="save-user">
                    {" "}
                    {!!isEdit ? "Update" : "Add"}{" "}
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>

      {/*Informacion adicional de la Wallet */}
      <Modal isOpen={modalInfo} toggle={toggleinfo}>
        <ModalHeader toggle={toggleinfo} tag="h4">
          {" "}
          {"Información de la Wallet"}
        </ModalHeader>
        <ModalBody>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <Row>
              <Col xs={12}>
                {/* NAME */}
                <div className="mb-3">
                  <Label>Name</Label>
                  <Input
                    name="name"
                    type="text"
                    disabled={true}
                    value={walletDataInfo.name || ""}
                  />
                </div>
                {/* BALANCE */}
                <div className="mb-3">
                  <Label>Balance</Label>
                  <Input
                    name="name"
                    type="number"
                    disabled={true}
                    value={walletDataInfo.balance || 0}
                  />
                </div>
                {/* Wallet Type */}
                <div className="mb-3">
                  <Label>Tipo de Wallet</Label>
                  <Input
                    name="name"
                    type="text"
                    disabled={true}
                    value={walletDataInfo.wallet_type || ""}
                  />
                </div>
                {/* Crypto Currency */}
                <div
                  className="mb-3"
                  hidden={walletDataInfo.crypto_currency_id === null}
                >
                  <Label>Moneda Cripto</Label>
                  <Input
                    name="name"
                    type="text"
                    disabled={true}
                    value={cryptoCurrency.map((currency) =>
                      currency.id === walletDataInfo.crypto_currency_id
                        ? currency.name
                        : null
                    )}
                  />
                </div>
                {/* Fiat Currency */}
                <div
                  className="mb-3"
                  hidden={walletDataInfo.fiat_currency_id === null}
                >
                  <Label>Moneda Fiat</Label>
                  <Input
                    name="name"
                    type="text"
                    disabled={true}
                    value={fiatCurrencies.map((currency) =>
                      currency.id === walletDataInfo.fiat_currency_id
                        ? currency.name
                        : null
                    )}
                  />
                </div>
                {/* Status */}
                <div className="mb-3">
                  <Label>Estado</Label>
                  <Input
                    name="name"
                    type="text"
                    disabled={true}
                    value={walletDataInfo.status_id || ""}
                  />
                </div>
                {/* Created At */}
                <div className="mb-3">
                  <Label>Creado en</Label>
                  <Input
                    name="name"
                    type="text"
                    disabled={true}
                    value={walletDataInfo.created_at || ""}
                  />
                </div>
                {/* Networks */}
                <div className="mb-3">
                  <Label>Network</Label>
                  <Input
                    name="name"
                    type="text"
                    disabled={true}
                    value={walletDataInfo.network_id || ""}
                  />
                </div>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default WalletActivities;
